import type { Season } from '@src/theme/season';
export interface GiftPreviewPreset { panX: number; panY: number; zoom: number; giftX: number; giftY: number; giftScale: number }
export const DEFAULT_GIFT_PRESET: GiftPreviewPreset = { panX: 0, panY: 0, zoom: 1, giftX: 0, giftY: 0, giftScale: 1 };
export const GIFT_PRESET_KEY = 'santa-gift-preview-presets-v1';
export const giftPresetId = (season: Season, mobile: boolean, mode: string) => `${season}:${mobile ? 'mobile' : 'desktop'}:${mode}`;
export function readGiftPresets(): Record<string, GiftPreviewPreset> {
  try { return JSON.parse(localStorage.getItem(GIFT_PRESET_KEY) || '{}'); } catch { return {}; }
}
